const strings = {
    choosePageText: 'escolher página',
    ariaLabels: {
        prevPage: 'retroceder página',
        page: 'página',
        nextPage: 'avançar página',
    },
};

export { strings };
